import Vue from "vue";
import Router from "vue-router";
import PortalLayout from "../views/PortalLayout";
import Profile from "../views/Profile";
import Financieel from "../views/Financieel";
import Inhaallessen from "../views/Inhaallessen";
import InhaallesNieuw from "../views/InhaallesNieuw";
import Login from "../views/Login";

Vue.use(Router);

const router = new Router({
  mode: "history",
  linkActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "login",
      components: {
        main: Login
      }
    },
    {
      path: "/main",
      components: {
        main: PortalLayout
      },
      children: [
        {
          path: "",
          name: "profile",
          component: Profile
        },
        {
          path: "financieel",
          name: "financieel",
          component: Financieel
        },
        {
          path: "inhaallessen",
          name: "inhaallessen",
          component: Inhaallessen
        },
        {
          path: "inhaallessen/nieuw",
          name: "inhaalles-nieuw",
          component: InhaallesNieuw
        }
      ]
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});

router.beforeEach(function(to, from, next) {
  var access = localStorage.getItem("access") === "true";
  var isMain = to.path === "/main" || to.path.indexOf("/main/") === 0;
  if (isMain && !access) {
    next({ path: "/" });
    return;
  }
  if (to.path === "/" && access) {
    next({ path: "/main" });
    return;
  }
  next();
});

export default router;
